import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardContainerComponent } from './dashboard-container/dashboard-container.component';
import { ProjectsComponent } from './projects/projects.component';

import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { PieChartComponent } from './pie-chart/pie-chart.component';
import { ProjectComponent } from './project/project.component';

import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ProjectDialogComponent } from './project-dialog/project-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatRadioButton, MatRadioModule } from '@angular/material/radio';
import { AddItemProjectDialogComponent } from './add-item-project-dialog/add-item-project-dialog.component';
import { AssociateEstimatesDialogComponent } from './associate-estimates-dialog/associate-estimates-dialog.component';
import { CombinedResultEstimateComponent } from './combined-result-estimate/combined-result-estimate.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EditInitialCostDialogComponent } from './edit-initial-cost-dialog/edit-initial-cost-dialog.component';



@NgModule({
  declarations: [
    DashboardComponent,
    DashboardContainerComponent,
    PieChartComponent,
    ProjectsComponent,
    ProjectComponent,
    ProjectDialogComponent,
    AddItemProjectDialogComponent,
    AssociateEstimatesDialogComponent,
    CombinedResultEstimateComponent,
    EditInitialCostDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    FormsModule,
    MatTableModule,
    MatSortModule,
    MatSelectModule,
    MatFormFieldModule,
    MatCardModule,
    FlexLayoutModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatDialogModule,
    MatInputModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatTooltipModule,
    NgxMatSelectSearchModule
  ],
  exports: [
    DashboardComponent,
  ]
})
export class DashboardModule { }
